import React, { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../../_metronic/_helpers";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../../_metronic/_partials/controls";
import {
  createNotificationTemplate,
  findNotificationTemplateById,
  updateNotificationTemplate
} from "../../../_redux/notification-template/notificationTemplateAction";
import LoadingAnimation from "../loading-animation/LoadingAnimation";
import NotificationTemplateCreateForm from "./NotificationTemplateEditForm";

export default function NotificationTemplateForm({
  history,
  match: {
    params: { id }
  }
}) {
  const dispatch = useDispatch();

  const { actionsLoading, notificationTemplateForEdit = {} } = useSelector(
    state => state.superadminNotificationTemplates,
    shallowEqual
  );

  useEffect(() => {
    dispatch(findNotificationTemplateById(id));
  }, []);

  const onSubmit = values => {
    if (id) {
      dispatch(updateNotificationTemplate(values))
        .then(res => {
          toast.success(res.data.message, toastOption);
          history.push("/admin/template-notification");
        })
        .catch(err => {
          toast.error(err.message);
        });
    } else {
      dispatch(createNotificationTemplate(values))
        .then(res => {
          toast.success(res.data.message, toastOption);
          history.push("/admin/template-notification");
        })
        .catch(err => {
          toast.error(err.message);
        });
    }
  };

  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      <Card>
        <CardHeader title="Tambah Lembaga">
          <CardHeaderToolbar>
            <button
              className="btn btn-secondary"
              onClick={() => history.goBack()}
            >
              Kembali
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <NotificationTemplateCreateForm
            onSubmit={onSubmit}
            initialValues={id ? notificationTemplateForEdit || {} : {}}
          />
        </CardBody>
      </Card>
    </>
  );
}
